// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fontSize[data-v-b13a4008]{\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
